module.exports = __webpack_public_path__ + "static/img/10.2a77511.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/10.png
// module id = S8qY
// module chunks = 0